/** global SN_GLOBALS */
jQuery((function($) {
	var site    = {};

	// Globals defined in scripts.php
	// ajaxurl = SN_GLOBALS.ajaxurl

	/**
	 * Initialize FlexSliders here
	 *
	 * @example http://flexslider.woothemes.com/
	 *
	 * @return boolean false
	 */
	// site.initFlexslider = function() {
	// 	if (typeof $.fn.flexslider !== 'function' ) {
	// 		return;
	// 	} // if()

	// 	var slider = $('.flexslider');

	// 	// Check if a slider exists
	// 	if ( slider.length === 0 ) {
	// 		return false;
	// 	}

	// 	return false;
	// }; // site.initFlexslider()

	/**
	 * Initializes FitVid  jQuery plugin.
	 *
	 * @example http://fitvidsjs.com/
	 *
	 * @return  {Void}
	 */
	site.initFitVids = function() {
		if ( typeof $.fn.fitVids !== 'function' ) {
			return;
		} // if()

		$('.fitvid').fitVids();
	}; // site.initFitVids()

	/**
	 * Adding selectric jQuery plugin.
	 *
	 * @example http://lcdsantos.github.io/jQuery-Selectric/
	 *
	 * @return  {void}
	 */
	// site.selectricInit = function() {
	// 	if ( typeof $.fn.selectric !== 'function' ) {
	// 		return;
	// 	} // if()

	// 	var selectElem = $('select');
	// 	if ( selectElem.length === 0 ) {
	// 		return;
	// 	} // if()

	// 	selectElem.selectric();

	// 	if ( $('.selectricWrapper').length === 0 ) {
	// 		selectElem.addClass('selectric-disabled');
	// 		$('form').addClass('selectric-disabled-form');
	// 	} // if()
	// }; // site.selectricInit()

	/**
	 * Scrolls the page to the top of the provided element
	 *
	 * @param  {object}          elem            The jQuery selector object to scroll to.
	 * @param  {string}          [easing=linear] The easing used when scrolling.
	 * @param  {(string|number)} [speed=1500]    The speed to scroll.
	 * @param {number}           [offsetTop=10]  Offset above the top of the element to scroll to.
	 *
	 * @return boolean               false
	 */
	site.scollTo = function( elem, easing, speed, offsetTop ) {
		speed     = ( typeof speed === 'undefined' ) ? 1500 : speed;
		easing    = ( typeof easing === 'undefined' ) ? 'linear' : easing;
		offsetTop = ( typeof offsetTop === 'undefined' ) ? 10 : offsetTop;

		var offset = elem.offset().top - offsetTop;
		$('html,body').animate( { scrollTop : offset }, speed, easing );

		return false;
	}; // site.scollTo()

	/**
	 * Initializes the back to top button.
	 *
	 * @todo Possibly add parameters but we will see
	 *
	 * @return  {void}
	 */
	site.initBackToTop = function() {
		var pageTopLinkElem = $('.page-top-link');

		if ( pageTopLinkElem.length === 0 ) {
			return;
		} // if()

		pageTopLinkElem.click(function() {
			$(window.opera ? 'html' : 'html, body').stop(true, true).animate({ scrollTop : 0 }, 1500, 'easeInOutQuad');
			return false;
		});

		$(window).scroll(function() {
			if ($(window).scrollTop() > 150){
				pageTopLinkElem.stop(true, true).fadeIn(1000);
			} else {
				pageTopLinkElem.stop(true, true).fadeOut(1000);
			}
		});
	}; // site.initBackToTop()

	/**
	 * Document Ready
	 */
	$(document).ready(function() {
		site.initFitVids();
	});

	/**
	 * Window Resize.
	 */
	// $(window).resize(function() {
	// });

	/**
	 * Window Load
	 */
	$(window).load(function() {
		site.initBackToTop();
	});

	// Navigation
	$('.navbar-button').on('click', function( ) {
		$('body').toggleClass('menu-active');
	});

	// Leadership Modal
	$('body').on('click', '.leadership-modal-wrapper', function( ) {
		$('body').toggleClass('leadership-modal-active');
		$( '.leadership-modal .leadership-content-area' ).html('');
	});

	$('body').on('click', '.leadership-modal', function( e ) {
		e.stopPropagation();
	});

	$('body').on('click', '.leadership-modal .close-button', function( ) {
		$('body').toggleClass('leadership-modal-active');
		$( '.leadership-modal .leadership-content-area' ).html('');
	});

	$('body').on('click', '.leader-link', function( e ) {
		if ($('.leadership-modal').length !== 0) {
			$('body').toggleClass('leadership-modal-active');
			var pageurl = $(this).attr('href');
			$( '.leadership-modal .leadership-content-area' ).load( pageurl +" #single-leadership", function() {

			});
			e.preventDefault();
		}
	});

	// Project Slider
	$(window).load(function() {
	// The slider being synced must be initialized first
		$('#carousel').flexslider({
			animation: "slide",
			controlNav: false,
			animationLoop: false,
			slideshow: false,
			itemWidth: 170,
			itemMargin: 5,
			nextText: '',
			prevText: '',
			start: function($slider) {
				$slider.addClass('loaded');
			}
		});
	});

	$(document).ready(function() {
		$(".fancybox").fancybox({
			prevEffect	: 'none',
			nextEffect	: 'none',
			beforeLoad: function() {
				this.title = $(this.element).attr('caption');
			}
		});
	});

	// Projects filter dropdown
	$('.project-filter-dropdown').on('click', function() {
		$('.project-filter-section').toggleClass('filter-menu-open');
	});

	// Change Project Category
	$('.js .filters .filter').on('click', function(e) {
		$('.filters .filter').removeClass('active');
		$(this).addClass('active');
		$new_category_title = $(this).children('.category-title').html();
		//alert($new_category_title);
		$('.project-filter-dropdown .category-title').html( $new_category_title );

		$new_category_icon = $(this).children('.category-icon').html();
		$('.project-filter-dropdown .category-icon').html( $new_category_icon );
		e.preventDefault();
	});

	// init
	var $container = $('#projects-grid');
	$container.isotope({
		// options
		itemSelector: '.project-single-box',
		layoutMode: 'fitRows'
	});

	//Isotope Filters
	$('.js .all-filter').click(function() {
		$('#projects-grid').isotope({ filter: '*' });
	});

	// Filters
	$('.js .research-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.research' });
	});

	$('.js .cultural-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.cultural' });
	});

	$('.js .parks-and-recreation-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.parks-and-recreation' });
	});

	$('.js .memorial-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.memorial' });
	});


	$('.js .corporate-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.corporate' });
	});

	$('.js .academic-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.academic' });
	});

	$('.js .entertainment-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.entertainment' });
	});

	// Filters with Sub Categories
	$('.js .healthcare-filter').click(function() {
		$('.sub-menu.healthcare').addClass('active');
		$('.healthcare-filter').addClass('active');
		$('#projects-grid').isotope({ filter: '.healthcare' });
	});

	$('.js .research-filter').click(function() {
		$('.sub-menu.research').addClass('active');
		$('.research-filter').addClass('active');
		$('#projects-grid').isotope({ filter: '.research' });
	});

	// Sub Categories
	// Healthcare
	$('.js .diagnostic-treatment-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.diagnostic-treatment' });
	});

	$('.js .medical-office-building-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.medical-office-building' });
	});

	$('.js .patient-care-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.patient-care' });
	});

	$('.js .support-services-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.support-services' });
	});

	$('.js .master-planning-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.master-planning' });
	});

	// Research
	$('.js .life-sciences-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.life-sciences' });
	});

	$('.js .medical-imaging-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.medical-imaging' });
	});

	$('.js .plant-sciences-filter').click(function() {
		$('#projects-grid').isotope({ filter: '.plant-sciences' });
	});

	// Back Button
	$('.js .filter.back-button').click(function() {
		$('#projects-grid').isotope({ filter: '*' });
		$('.sub-menu').removeClass('active');
		$('.all-filter').addClass('active');
		$new_category_title = $('.all-filter').children('.category-title').html();
		$('.project-filter-dropdown .category-title').html( $new_category_title );

		$new_category_icon = $('.all-filter').children('.category-icon').html();
		$('.project-filter-dropdown .category-icon').html( $new_category_icon );
	});

	// Homepage scroll down button
	$(".scroll-arrow").click(function() {
		$('html, body').animate({
			scrollTop: $(".featured-project").offset().top-84
		}, 500);
	});

})(jQuery));
